import React, { useCallback, useState } from "react";

import { Switch, SwitchProps } from "antd";
import type { SwitchChangeEventHandler } from "rc-switch";

import Text from "../Text/Text";

import styles from "./BrandSwitch.module.scss";

type ToggleText = {
  on: string;
  off: string;
};

interface Props extends SwitchProps {
  toggleText?: ToggleText;
}

const BrandSwitch: React.FC<Props> = ({
  toggleText,
  onChange,
  checked,
  defaultChecked = false,
  ...rest
}) => {
  const isControlled = checked !== undefined;
  const [uncontrolledChecked, setUncontrolledChecked] = useState(!!defaultChecked);
  const isChecked = isControlled ? !!checked : uncontrolledChecked;

  const handleOnChange: SwitchChangeEventHandler = useCallback(
    (
      next: boolean,
      event:
        | React.MouseEvent<HTMLButtonElement>
        | React.KeyboardEvent<HTMLButtonElement>
    ) => {
      if (!isControlled) {
        setUncontrolledChecked(next);
      }
      if (onChange !== undefined) {
        onChange(next, event as React.MouseEvent<HTMLButtonElement>);
      }
    },
    [isControlled, onChange]
  );

  const switchEl = (
    <Switch {...rest} checked={isChecked} onChange={handleOnChange} />
  );

  if (toggleText !== undefined) {
    return (
      <div className={styles.switchContainer}>
        <Text className={styles.toggleText} size="md" type="text">
          {isChecked ? toggleText.on : toggleText.off}
        </Text>
        {switchEl}
      </div>
    );
  }

  return switchEl;
};

export default BrandSwitch;
